const all = ['importantInformations']
const lists = [...all, 'list']
const listAll = [...lists, 'all']

export const importantInformationsKeys = {
  all,
  lists,
  listAll,
}
